export { VideoPlayer } from './video-player';